import { RoleType } from 'types/shared/permissions';
import { BACKEND_API, getUrl } from 'helpers/http';

export const getPermissions = async (roleId: RoleType): Promise<any> => {
  return getUrl(BACKEND_API.PRISMA, `/auth/permissions/${roleId}`);
}

export const getVisibleRoles = async (roleId: RoleType): Promise<any> => {
  return getUrl(BACKEND_API.PRISMA, `/auth/visibleRoles/${roleId}`);
}